import { useState, useEffect } from 'react';
import { adminAPI } from '../services/api';

export interface Plan {
  id: string;
  name: string;
  description: string;
  monthlyPrice: number;
  planCode: string; // Added this property since backend transforms plan_code to planCode
  limits: any;
  features: any;
  planLimitMonths?: number;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  subscriberCount?: number;
  createdByEmail?: string;
  createdById?: string;
}

export const usePlans = (platform_name?: string) => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      setError(null);
      // Use getPlans which includes platform_name as query parameter
      const response = await adminAPI.getPlans();
      setPlans(response.data);
    } catch (err: any) {
      console.error('Error fetching plans:', err);
      setError(err.message || 'Failed to fetch plans');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, [platform_name]);

  return { plans, loading, error, refetch: fetchPlans };
}; 